/**
 * JWT 工具函数
 */

interface JwtPayload {
  exp?: number;
}

function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const decoded = atob(padded);
    return JSON.parse(decoded) as JwtPayload;
  } catch (_error) {
    return null;
  }
}

export function isJwtTokenFresh(
  token: string | null | undefined,
  skewMs = 5000
): boolean {
  if (!token) {
    return false;
  }

  const payload = decodeJwtPayload(token);
  const exp = payload?.exp;
  if (!exp) {
    return false;
  }

  const expireAt = exp * 1000;
  return expireAt > Date.now() + Math.max(0, skewMs);
}

